import * as React from "react"
import AppConfig from "../../configs/AppConfig"
import LanguageSwitcherRedux from "../../redux/languageSwitcher/languageSwitcherRedux"
import { connect } from "react-redux"
import "./languageSwitcher.css"

class LanguageSwitcher extends React.Component<
  {
    changeLanguage: (language: string) => void
    currentLang: string
  },
  {
    currentLang: string
  }
> {
  constructor(props) {
    super(props)
    this.state = {
      currentLang: this.props.currentLang
    }
  }

  public componentWillReceiveProps(newProps) {
    this.setState({ currentLang: newProps.currentLang })
  }

  public render() {
    const { currentLang } = this.props
    // if (!(currentLang === "th" || currentLang === "en")) {
    //   return <Redirect to={`/th`} />
    // }
    return (
        <a
          className="nav-link"
          // href="#"
          id="dropdownSelectLang"
          role="button"
          // data-toggle="dropdown"
          // aria-haspopup="true"
          // aria-expanded="false"
        >
          <img
            className="img rounded-circle"
            width="25"
            height="25"
            src={`${AppConfig.baseUrl}/images/flags/${
              this.props.currentLang
            }.png`}
            onClick={() => {
              this.props.changeLanguage(currentLang === "th" ? "en" : "th")
            }}
            onError={(e: any) => {
              e.target.onerror = null
              e.target.src = require(`../../images/flags/th.png`)
            }}
            alt="hiso-bus-rental-flag"
          />
        </a>
    )
  }
}

const mapStateToProps = state => {
  return {
    currentLang: state.Language.language
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changeLanguage: language =>
      dispatch(LanguageSwitcherRedux.changeLanguage(language))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LanguageSwitcher)



// WEBPACK FOOTER //
// ./src/components/languageSwitcher/languageSwitcher.tsx